import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPackageDetails } from "../services/api";

export const getPackageDetail = createAsyncThunk(
  "getPackageDetail",
  async (packageId, { rejectWithValue }) => {
    try {
      return await fetchPackageDetails(packageId);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load package");
    }
  }
);

const GetPackageDetailSlice = createSlice({
  name: "getPackageDetailReducer",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    clearGetPackageDetailData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPackageDetail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPackageDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getPackageDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load package";
      });
  },
});

export const { clearGetPackageDetailData } = GetPackageDetailSlice.actions;
export default GetPackageDetailSlice.reducer;
